<template>
  <v-dialog
    v-model="show"
    max-width="700"
    persistent
  >
    <v-card>
      <v-card-title class="headline">{{$t("message.dialog.title.inputConfirm")}}</v-card-title>
      <v-card-text>{{$t("message.dialog.desc.inputConfirm")}}</v-card-text>

      <v-container v-if="optionForm">

        <v-row justify="center">
          <v-col cols="12" md="10">
            <h2>{{$t("message.account.entry.title.account")}}</h2>
          </v-col>
        </v-row>

        <!-- ID -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.id")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.id }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 氏名 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.name")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.name }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 所属 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.group")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ groupLargeName }}<span class="mx-2">＞</span>{{ groupSmallName }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 会社 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{ companyLabel[$i18n.locale] }}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box v-if="companyName.base">{{ companyName.base }}</mp-input-box>
            <mp-input-box v-if="companyName.kana">{{ companyName.kana }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 支社・支局 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{ branchLabel[$i18n.locale] }}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box v-if="branchName.base">{{ branchName.base }}</mp-input-box>
            <mp-input-box v-if="branchName.kana">{{ branchName.kana }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 郵便番号 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.postNo")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.postNo }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 都道府県 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.prefCd")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ $store.getters.prefNameByCode(optionForm.prefCd)[$i18n.locale] }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 市区町村 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.addr1")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.addr1 }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 番地 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.addr2")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.addr2 }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- ビル名 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.addr3")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.addr3 }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 部署 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.busho")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.busho }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 電話番号 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.telNo")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.telNo }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 備考 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.remarks")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line pr-0">
            <mp-multiple-lines-input-box>{{ optionForm.remarks }}</mp-multiple-lines-input-box>
          </v-col>
        </v-row>

        <!-- 利用希望サービス -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.account.entry.label.services")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>
              <ul class="serviceList">
                <li v-for="s in serviceNameList" :key="s">
                  {{ s }}
                </li>
              </ul>
            </mp-input-box>
          </v-col>
        </v-row>

        <!-- フリーランス申請 start -->
        <template v-if="optionfreelanceForm">
          <v-row justify="center">
            <v-col cols="12" md="10">
              <h2 class="mt-5">{{$t("message.account.entry.title.freelance")}}</h2>
            </v-col>
          </v-row>

          <!-- 推薦社名 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.recommendationCompanyName")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line">
              <mp-input-box>{{ optionfreelanceForm.recommendationCompanyName }}</mp-input-box>
            </v-col>
          </v-row>

          <!-- 推薦媒体名 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.recommendationMediaName")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line">
              <mp-input-box>{{ optionfreelanceForm.recommendationMediaName }}</mp-input-box>
            </v-col>
          </v-row>

          <!-- 媒体内容 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.mediaContents")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line pr-0">
              <mp-multiple-lines-input-box>{{ optionfreelanceForm.mediaContents }}</mp-multiple-lines-input-box>
            </v-col>
          </v-row>

          <!-- 媒体発行詳細 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.mediaIssueDetail")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line pr-0">
              <mp-multiple-lines-input-box>{{ optionfreelanceForm.mediaIssueDetail }}</mp-multiple-lines-input-box>
            </v-col>
          </v-row>

          <!-- 推薦責任者名 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.recommendationResponsibleName")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line">
              <mp-input-box>{{ optionfreelanceForm.recommendationResponsibleName }}</mp-input-box>
            </v-col>
          </v-row>

          <!-- 推薦責任者メールアドレス -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.recommendationResponsibleMailAddress")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line">
              <mp-input-box>{{ optionfreelanceForm.recommendationResponsibleMailAddress }}</mp-input-box>
            </v-col>
          </v-row>

          <!-- 推薦理由 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.recommendationReason")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line pr-0">
              <mp-multiple-lines-input-box>{{ optionfreelanceForm.recommendationReason }}</mp-multiple-lines-input-box>
            </v-col>
          </v-row>

          <!-- 取材活動実績 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.trackRecord")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line pr-0">
              <mp-multiple-lines-input-box>{{ optionfreelanceForm.trackRecord }}</mp-multiple-lines-input-box>
              <div class="mt-5">
                <div v-for="file in optionfreelanceForm.uploadFiles" :key="file.path">
                  <p class="mb-2">
                    <span class="fileName">{{ file.name }}</span>
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </template>
        <!-- フリーランス申請 end -->

        <!-- ローカルメディア申請 start -->
        <template v-if="optionLocalMediaForm">
          <v-row justify="center">
            <v-col cols="12" md="10">
              <h2 class="mt-5">{{$t("message.account.entry.title.localMedia")}}</h2>
            </v-col>
          </v-row>

          <!-- 媒体発行詳細 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.mediaIssueDetail")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line pr-0">
              <mp-multiple-lines-input-box>{{ optionLocalMediaForm.mediaIssueDetail }}</mp-multiple-lines-input-box>
            </v-col>
          </v-row>

          <!-- 媒体カバーエリア -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.mediaCoverageArea")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line pr-0">
              <mp-multiple-lines-input-box>{{ optionLocalMediaForm.mediaCoverageArea }}</mp-multiple-lines-input-box>
            </v-col>
          </v-row>

          <!-- グループ責任者名 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.groupResponsibleName")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line">
              <mp-input-box>{{ optionLocalMediaForm.groupResponsibleName }}</mp-input-box>
            </v-col>
          </v-row>

          <!-- 利用者名 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.userName")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line pr-0">
              <mp-multiple-lines-input-box>{{ optionLocalMediaForm.userName }}</mp-multiple-lines-input-box>
            </v-col>
          </v-row>

          <!-- ローカル媒体管理クラブ -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.localMediaManagementClub")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line">
              <mp-input-box>
                <p v-for="clubCode in optionLocalMediaForm.localMediaManagementClub" :key="clubCode">{{ $store.getters.localMediaManagementClubNameByCode(clubCode)[$i18n.locale] }}</p>
              </mp-input-box>
            </v-col>
          </v-row>

          <!-- 利用者名 -->
          <v-row justify="center">
            <v-col cols="4" md="4">
              <mp-label>{{$t("message.account.entry.label.other")}}</mp-label>
            </v-col>
            <v-col cols="8" md="6" class="confirm-line pr-0">
              <mp-multiple-lines-input-box>{{ optionLocalMediaForm.other }}</mp-multiple-lines-input-box>
            </v-col>
          </v-row>

        </template>
    <!-- ローカルメディア申請 end -->

      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <mp-button min class="btn-half-wide" @click="handleClickCancel">{{$t("message.dialog.button.cancel")}}</mp-button>
        <v-spacer></v-spacer>
        <mp-button min class="btn-half-wide" @click="handleClickOk">{{$t("message.dialog.button.ok")}}</mp-button>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/message'
import constantValue from '@/constantValue'
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpMultipleLinesInputBox from '@/components/item/MpMultipleLinesInputBox.vue'

export default {
  components: {
    MpLabel,
    MpInputBox,
    MpButton,
    MpMultipleLinesInputBox
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    optionForm: {
      type: Object,
      default: null
    },
    optionfreelanceForm: {
      type: Object,
      default: null
    },
    optionLocalMediaForm: {
      type: Object,
      default: null
    },
    group: {
      type: Array,
      default: null
    },
    company: {
      type: Array,
      default: null
    },
    branch: {
      type: Array,
      default: null
    },
    service: {
      type: Array,
      default: null
    },
    companyLabel: {
      type: Object,
      default: () => {
        return {
          ja: '',
          en: ''
        }
      }
    },
    branchLabel: {
      type: Object,
      default: () => {
        return {
          ja: '',
          en: ''
        }
      }
    }
  },
  computed: {
    groupLargeName () {
      for (const g of this.group) {
        if (g.groupLargeId === this.optionForm.groupLargeId) {
          return g.groupLargeName[i18n.locale]
        }
      }
      return ''
    },
    groupSmallName () {
      for (const g of this.group) {
        if (g.groupLargeId === this.optionForm.groupLargeId) {
          for (const sg of g.groupSmallList) {
            if (sg.groupSmallId === this.optionForm.groupSmallId) {
              return sg.groupSmallName[i18n.locale]
            }
          }
        }
      }
      return ''
    },
    companyName () {
      if (this.optionForm.companyId === constantValue.otherCompanyId) {
        return { base: this.optionForm.companyName, kana: this.optionForm.companyNameKana }
      }
      for (const c of this.company) {
        if (c.companyId === this.optionForm.companyId) {
          return { base: c.companyName }
        }
      }
      return {}
    },
    branchName () {
      if (this.optionForm.branchId === constantValue.otherBranchId) {
        return { base: this.optionForm.branchName, kana: this.optionForm.branchNameKana }
      }
      for (const b of this.branch) {
        if (b.branchId === this.optionForm.branchId) {
          return { base: b.branchName }
        }
      }
      return {}
    },
    serviceNameList () {
      const res = []
      for (const s of this.service) {
        if (this.optionForm.services.includes(s.serviceId)) {
          res.push(s.serviceName[i18n.locale])
        }
      }
      return res
    }
  },
  methods: {
    // OKクリック時
    handleClickOk (ev) {
      // 親のclickOkを呼び出し
      this.$emit('clickOk', ev)
    },
    // キャンセルクリック時
    handleClickCancel (ev) {
      // 親のclickCancelを呼び出し
      this.$emit('clickCancel', ev)
    }
  }
}
</script>

<style scoped>
.confirm-line {
  border-bottom: solid 1px rgba(0, 0, 0, 0.33);
}
.btn-half-wide {
  width: 45%;
}
</style>
